interface Props {
    children: React.ReactNode
    className?: string
}

export const Text = ({ children, className }: Props) => (
    <span className={`text-gray-800 text-base ${className ?? ''}`}>
        {children}
    </span>
)

export const PrimaryText = ({ children, className }: Props) => (
    <span
        className={`font-ubuntu-medium text-primary-800 text-base ${
            className ?? ''
        }`}>
        {children}
    </span>
)
